import { QueryType } from "../../../Helper/constants";
import { addBenToEmailJobHttp } from "../../../Http/Index"


export const addBenToEmailJob = async ({ jobId, payload }: { jobId: string, payload: { queryType: QueryType, query: Object } }) => {
    try {
        if (!Object.keys(payload?.query)?.length) {
            alert("Query is empty")
            return
        }
        await addBenToEmailJobHttp({ jobId, payload });
        alert("Adding Ben Data Is In Progress, Please refresh the page after some time if loading takes time");
        window.location.reload();
    } catch (error: any) {
        alert(error?.response?.data?.message)
    }
}